import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';

/** renders a back button
 * if action===true then use router to go back
 * else call the action
*/
const BackButton = ({ action, router }) => {
  function onClick(e) {
    e.preventDefault();
    if (action === true) {
      if (router && typeof router.goBack === 'function') {
        router.goBack();
      } else {
        throw new Error('must pass router as a prop in order to use default back action');
      }
    } else if (typeof action === 'function') {
      action(e);
    }
  }
  
  return (
    <a className="back-button"
      onClick={onClick}
      aria-label="back"
      data-back-arrow={true}>
      <Icon iconType="arrow-back" />
    </a>
  );
}

BackButton.propTypes = {
  action: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func
  ]),
  router: PropTypes.shape({
    goBack: PropTypes.func
  })
};

export default BackButton;
